// extracted by mini-css-extract-plugin
module.exports = {"SecondStep":"SecondStep_SecondStep__N-ufr","PinkBg":"SecondStep_PinkBg__3IbPJ","CustomNumClass":"SecondStep_CustomNumClass__CdIdl","Title":"SecondStep_Title__4KVy7"};